module.exports = __webpack_public_path__ + "static/img/project_4.c59a0c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/project_4.jpg
// module id = buTC
// module chunks = 0